/* eslint-disable no-useless-constructor */
import networkList from '../constants/networkList';
import axios from 'axios';
import { Modal } from 'antd';
import Storage from './local-store';

const { otm_base_url,homepage } = networkList;

const HttpClient = axios.create({
    baseURL: otm_base_url,
    headers: {
        'Content-Type': 'application/json',
        "accept": "application/json"
    }
});
export default function otmpostService(url, method, data) {
    const token = JSON.parse(Storage.get('token'));
    return HttpClient({
        method: method,
        url: url,
        data: data,
        headers: {
            'authorization': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6ImFkbWluIiwicGFzc3dvcmQiOiJhZG1pbiIsImlhdCI6MTU1ODkzMTU5OSwiZXhwIjoxNTU5MDE3OTk5fQ.WjXnqxRMrxrK6NyCG-Mt6FqLQl36y4myXiPn1dApYik'
        }
    }).then(function (response) {
        const { data } = response;
        const { status } = response;
        if (status === 200) {
            if (data.status) {
                return data;
            } else {
                // Modal.error({title: data.message});
                return data;
            }
        } else if (status === 401) {
            Modal.error({
                'title': "Unauthorised Access",
                'content': `${data.message}`,
                onOk: () => {
                    localStorage.clear();
                    window.location.replace('/');
                }
            })
        } else {
            return false;
        }
    }).catch(async function (error) {
        console.log(error.response);
        let { status, data } = error.response ? error.response : {};
        if (status && status === 401) {
            Modal.error({
                'title': "Unauthorised Access",
                'content': `${data.message}`,
                onOk: () => {
                    localStorage.clear();
                    window.location.replace('/');
                }
            })
            return status
        } else {
            //Modal.error({zIndex:1600,title: error.message});
            return false;
        }


    });
}